import { render, staticRenderFns } from "./legalassistance.vue?vue&type=template&id=22733d02&scoped=true&"
import script from "./legalassistance.vue?vue&type=script&lang=js&"
export * from "./legalassistance.vue?vue&type=script&lang=js&"
import style0 from "./legalassistance.vue?vue&type=style&index=0&id=22733d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22733d02",
  null
  
)

export default component.exports